import { skillSet } from "../utils/constant";

const Skill = () => {
  return (
    <section id="team">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2 class="wow bounceIn" data-wow-offset="50" data-wow-delay="0.3s">
              <span>SKILLS</span> THAT I'M CONFIDENT
            </h2>
          </div>
          {skillSet.map((item) => (
            <div
              key={item}
              class="col-md-3 col-sm-6 col-xs-12 wow fadeIn mb-3"
              data-wow-offset="50"
              data-wow-delay="1.3s"
            >
              <div class="team-wrapper">
                <img
                  src="images/team-img1.jpg"
                  class="img-responsive"
                  alt="team img 1"
                />
                <div class="team-des">
                  <span>{item.name}</span>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                    elitquisque tempus ac eget diam et laoreet phasellus ut nisi
                    id leo molest.
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skill;
